import { useState, useEffect } from 'react';
import networkQuality from 'utils/networkQuality';

const useNetworkQuality = () => {
  const [signal, setSignal] = useState(networkQuality.getSignal());

  useEffect(() => {
    return networkQuality.subscribe(setSignal);
  }, []);

  return signal;
};

export default useNetworkQuality;
